module.exports = __webpack_public_path__ + "img/05.ea24a025.png";